import {FETCH_TAXSETTING_BEGIN,FETCH_TAXSETTING_SUCCESS,FETCH_TAXSETTING_FAILURE} from '../constants/taxsetting';

const initialState={
    taxSetting:[],
    isLoading:false,
    error:""
}


export const getTaxSettingReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_TAXSETTING_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_TAXSETTING_SUCCESS:
        return {
            ...initialState,
            isLoading:false,
            taxSetting:payload.taxSetting
        };
    case FETCH_TAXSETTING_FAILURE:
        return {
            ...initialState,
            error:payload.error,
            isLoading:true,
        };
    default:
        return state;
 }
}

export default getTaxSettingReducer
